import React, { memo, useContext, useCallback, useState } from 'react';
import { useDrop } from 'react-dnd';
import { Card } from './card';
import update from 'immutability-helper';
import { ItemTypes } from './itemTypes';
import { firebaseClient } from "../../firebaseClient";
import { getAccount } from "../../utils/sessionHelper";
import {
    Box,
    useColorModeValue as mode,
    Text,
    useDisclosure,
} from "@chakra-ui/react";
import { isToday, isTomorrow, format } from "date-fns";
import { useSession } from "next-auth/react";
import { TweetContext } from "../../context/tweetContext";
import toast from "react-hot-toast";
import * as Sentry from "@sentry/nextjs";

//@ts-ignore
export const Container = memo(function Container({slots, setSlots, timezoneDiff, refresh}) {

    // const [cards, setCards] = useState(ITEMS);
    const [hoveredId, setHoveredId] = useState("");
    const [selectedTweet, setSelectedTweet] = useState({text: "", id: ""});
    const { data: session, status } = useSession() ?? {}
    const loading = status === "loading"


    const tweetContext: any = useContext(TweetContext);
    
    const { isOpen: isOpenTweet, onOpen: onOpenTweet, onClose: onCloseTweet } = useDisclosure();

    React.useEffect(() => {
        // console.log("refresh");
    }, [refresh]);
    
    const findCard = useCallback((id) => {

        for (let i=0; i<slots.length; i++) {
            for (let j=0; j<slots[i].slotsOfTheDay.length; j++) {
                // console.log("checking " + slots[i].slotsOfTheDay[j].id);
                if (slots[i].slotsOfTheDay[j].id == id) {
                    return slots[i].slotsOfTheDay[j];
                }
            }
        }

        // console.log("slot not found: " + id);

        return null;

        // const card = slots.filter((c) => `${c.id}` === id)[0];
        // return {
        //     card,
        //     index: slots.indexOf(card),
        // };
    }, [slots]);

    const hoverCard = useCallback((card) => {
        // console.log("hoverCard");
        // for (let i=0; i<slots.length; i++) {
        //     for (let j=0; j<slots[i].slotsOfTheDay.length; j++) {
        //         slots[i].slotsOfTheDay[j].isHovered = false;
        //     }
        // }
        // card.isHovered = true;
        // setSlots([...slots]);
        setHoveredId(card.id);

    }, [findCard, slots, setSlots]);

    const saveCards = async function (card, to) {

        try {

            console.log("moveCard2 - card: " + JSON.stringify(card) + " / to: " + JSON.stringify(to));
    
            const db = firebaseClient.firestore();
            let tempTweet = slots[card.dayIndex].slotsOfTheDay[card.slotIndex].tweet;
    
            if (slots[to.dayIndex].slotsOfTheDay[to.slotIndex].tweet) {
                let tweet = slots[to.dayIndex].slotsOfTheDay[to.slotIndex].tweet;
    
                slots[card.dayIndex].slotsOfTheDay[card.slotIndex].tweet = tweet;
                // console.log("getAccount(session).id: " + getAccount(session).id);
                // console.log("tweet.id: " + tweet.id);
                await db.collection("users").doc(getAccount(session).id).collection("tweets").doc(tweet.id)
                    .update({scheduledTime: new Date(slots[card.dayIndex].slotsOfTheDay[card.slotIndex].time.getTime() + (1000*60*timezoneDiff))})
                    .catch(e => {
                        toast.error("Error during scheduling change");
                        console.log("Error during scheduling change: " + e.message);
                        Sentry.captureException(e);
                    });
            }
            else {
                slots[card.dayIndex].slotsOfTheDay[card.slotIndex].tweet = null;
            }

            
            if (tempTweet) {
                slots[to.dayIndex].slotsOfTheDay[to.slotIndex].tweet = tempTweet;
                await db.collection("users").doc(getAccount(session).id).collection("tweets").doc(tempTweet.id)
                    .update({scheduledTime: new Date(slots[to.dayIndex].slotsOfTheDay[to.slotIndex].time.getTime() + (1000*60*timezoneDiff))})
                    .catch(e => {
                        toast.error("Error during scheduling change");
                        console.log("Error during scheduling change: " + e.message);
                        Sentry.captureException(e);
                    });
            }
            else 
                slots[to.dayIndex].slotsOfTheDay[to.slotIndex].tweet = null;
    
            setSlots([...slots]);
            setHoveredId("");
    
            tweetContext.refresher({});
        }
        catch (e) {
            console.error(e);
            Sentry.captureException(e);
            throw e;
        }
    };

    const moveCard = useCallback(async (id, to=undefined as any) => {

        // console.log("moveCard - id: " + JSON.stringify(id) + " / to: " + JSON.stringify(to));
        // const { card, index } = findCard(id);
        var card = findCard(id);

        if (!to) {
            console.log("hoveredId: " + hoveredId);
            to = findCard(hoveredId);
        }

        if (!to || !card || to.isEvergreen)
            return;

        toast.promise(
            saveCards(card, to),
            {
                loading: 'Switching ... ',
                success: 'Updated',
                error: 'An error happened',
            }
        );

        // console.log({id});
        // console.log({to});

    }, [findCard, slots, setSlots, hoveredId]);

    const openTweet = (tweet) => {
        if (tweet?.text) {
            tweetContext.setSelectedTweetPreview(tweet);
            tweetContext.onOpenTweetPreview();
        }
    }

    const [, drop] = useDrop(() => ({ accept: ItemTypes.CARD }));

    return (
      <Box ref={drop}>
        {slots?.map((day, index) => (
          <Box mt={7} key={"day-" + index + "-" + day.time.getTime()}>
            <Text pb={4} textStyle={"h3.bold.standard"}>
              {isToday(day.time) ? "Today | " : ""}
              {isTomorrow(day.time) ? "Tomorrow | " : ""}
              {isToday(day.time) || isTomorrow(day.time)
                ? format(day.time, "MMMM dd")
                : format(day.time, `EEEE | MMMM dd ${new Date(day.time).getFullYear() > new Date().getFullYear() ? " '’'yy" : ""}`)}
            </Text>
            {day?.slotsOfTheDay?.map((card) => (
              <Box key={"card-" + card.id}>
                {
                  <Card
                    key={card.id}
                    //@ts-ignore
                    id={card.id}
                    card={card}
                    time={card.time}
                    isHovered={hoveredId == card.id}
                    text={card.text}
                    moveCard={moveCard}
                    findCard={findCard}
                    hoverCard={hoverCard}
                    openTweet={openTweet}
                  />
                }
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    );
});
